import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="calendar_date_time" size=32 />
 */

var CalendarDateTime = function CalendarDateTime() {
  return React.createElement(React.Fragment, null, React.createElement("g", {
    clipPath: "url(#clip0_5_1917)"
  }, React.createElement("path", {
    d: "M27.5795 4.7323H9.30594C8.81863 4.7323 8.42358 5.12734 8.42358 5.61465V24.197C8.42358 24.6843 8.81863 25.0794 9.30594 25.0794H27.5795C28.0668 25.0794 28.4618 24.6843 28.4618 24.197V5.61465C28.4618 5.12734 28.0668 4.7323 27.5795 4.7323Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30583 5.17349C9.06217 5.17349 8.86465 5.37101 8.86465 5.61467V24.197C8.86465 24.4407 9.06217 24.6382 9.30583 24.6382H27.5794C27.823 24.6382 28.0205 24.4407 28.0205 24.197V5.61467C28.0205 5.37101 27.823 5.17349 27.5794 5.17349H9.30583ZM7.9823 5.61467C7.9823 4.8837 8.57486 4.29114 9.30583 4.29114H27.5794C28.3103 4.29114 28.9029 4.8837 28.9029 5.61467V24.197C28.9029 24.928 28.3103 25.5205 27.5794 25.5205H9.30583C8.57486 25.5205 7.9823 24.928 7.9823 24.197V5.61467Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M27.5795 8.90588H9.30594C8.81863 8.90588 8.42358 9.30093 8.42358 9.78824V24.1971C8.42358 24.6844 8.81863 25.0794 9.30594 25.0794H27.5795C28.0668 25.0794 28.4618 24.6844 28.4618 24.1971V9.78824C28.4618 9.30093 28.0668 8.90588 27.5795 8.90588Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30583 9.34707C9.06217 9.34707 8.86465 9.5446 8.86465 9.78825V24.1971C8.86465 24.4407 9.06217 24.6383 9.30583 24.6383H27.5794C27.823 24.6383 28.0205 24.4407 28.0205 24.1971V9.78825C28.0205 9.5446 27.823 9.34707 27.5794 9.34707H9.30583ZM7.9823 9.78825C7.9823 9.05729 8.57486 8.46472 9.30583 8.46472H27.5794C28.3103 8.46472 28.9029 9.05729 28.9029 9.78825V24.1971C28.9029 24.928 28.3103 25.5206 27.5794 25.5206H9.30583C8.57486 25.5206 7.9823 24.928 7.9823 24.1971V9.78825Z",
    fill: "#002D55"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6264 1.90005C14.2754 1.90005 13.9387 2.0395 13.6905 2.28771C13.4423 2.53592 13.3029 2.87256 13.3029 3.22358V6.79711H12.4205V3.22358C12.4205 2.63855 12.6529 2.07747 13.0666 1.66379C13.4803 1.2501 14.0414 1.0177 14.6264 1.0177C15.2115 1.0177 15.7725 1.2501 16.1862 1.66379C16.5999 2.07747 16.8323 2.63855 16.8323 3.22358V4.42358H15.9499V3.22358C15.9499 2.87256 15.8105 2.53592 15.5623 2.28771C15.3141 2.0395 14.9774 1.90005 14.6264 1.90005Z",
    fill: "#002D55"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9824 1.90005C22.6313 1.90005 22.2947 2.0395 22.0465 2.28771C21.7983 2.53592 21.6588 2.87256 21.6588 3.22358V6.79711H20.7765V3.22358C20.7765 2.63855 21.0089 2.07747 21.4226 1.66379C21.8363 1.2501 22.3973 1.0177 22.9824 1.0177C23.5674 1.0177 24.1285 1.2501 24.5422 1.66379C24.9558 2.07747 25.1883 2.63855 25.1883 3.22358V4.42358H24.3059V3.22358C24.3059 2.87256 24.1665 2.53592 23.9182 2.28771C23.67 2.0395 23.3334 1.90005 22.9824 1.90005Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M8.43241 30.5588C11.4927 30.5588 13.9736 28.0779 13.9736 25.0176C13.9736 21.9573 11.4927 19.4764 8.43241 19.4764C5.3721 19.4764 2.89124 21.9573 2.89124 25.0176C2.89124 28.0779 5.3721 30.5588 8.43241 30.5588Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4323 19.9176C5.61565 19.9176 3.3323 22.201 3.3323 25.0176C3.3323 27.8343 5.61565 30.1176 8.4323 30.1176C11.249 30.1176 13.5323 27.8343 13.5323 25.0176C13.5323 22.201 11.249 19.9176 8.4323 19.9176ZM2.44995 25.0176C2.44995 21.7137 5.12834 19.0353 8.4323 19.0353C11.7363 19.0353 14.4147 21.7137 14.4147 25.0176C14.4147 28.3216 11.7363 31 8.4323 31C5.12834 31 2.44995 28.3216 2.44995 25.0176Z",
    fill: "#002D55"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86465 21.2941V24.197C8.86465 24.314 8.91113 24.4262 8.99387 24.509C9.07661 24.5917 9.18882 24.6382 9.30583 24.6382H11.6352V25.5205H9.30583C8.95481 25.5205 8.61816 25.3811 8.36995 25.1329C8.12174 24.8847 7.9823 24.548 7.9823 24.197V21.2941H8.86465Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M28.047 16.697H19.8235V24.6647",
    fill: "#B9DEFA"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_5_1917"
  }, React.createElement("rect", {
    width: "27.3529",
    height: "30",
    fill: "white",
    transform: "translate(2 1)"
  }))));
};

export default CalendarDateTime;